import { Component, Input } from '@angular/core';
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
} from '@angular/material/table';
import { RowLinkDirective } from '@ui/a11y/row-link/row-link.directive';
import { MatSort } from '@angular/material/sort';
import { B2BPartnerListResponse } from '@api/models/B2bService/Contract/B2bPartner/b-2-b-partner-list-response';
import { NoMatchesComponent } from '@ui/feedback/no-matches/no-matches.component';
import { PaginatorComponent } from '@ui/table/paginator/paginator.component';
import { PreLoaderModule } from '@ui/feedback/pre-loader/pre-loader.module';
import { AbstractGridComponent } from '@ui/base/abstract-grid/abstract-grid.component';
import { IconBsComponent } from '@ui/elements/icon-bs/icon-bs.component';
import { BsIconTypes } from '@ui/elements/icon-bs/bs-icon-types';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'users-partners-grid',
    imports: [
        MatCell,
        MatCellDef,
        MatColumnDef,
        MatHeaderCell,
        MatHeaderRow,
        MatHeaderRowDef,
        MatRow,
        MatRowDef,
        MatSort,
        MatTable,
        RowLinkDirective,
        NoMatchesComponent,
        PaginatorComponent,
        PreLoaderModule,
        MatHeaderCellDef,
        IconBsComponent,
        TranslatePipe,
    ],
    templateUrl: './partners-grid.component.html',
    styleUrl: './partners-grid.component.scss',
})
export class PartnersGridComponent extends AbstractGridComponent<B2BPartnerListResponse> {
    @Input()
    public displayedColumns: string[] = ['number', 'name', 'icons'];

    @Input()
    public set partners(partners: B2BPartnerListResponse[]) {
        if (partners) {
            this.displayEntities.data = partners;
        }
    }

    protected readonly bsIconTypes: typeof BsIconTypes = BsIconTypes;
}
